export default __webpack_public_path__ + "39fa9106bc9318ff10e6abc693d8bdd3.svg";